import SessionStorage from '@/services/repository/SessionStorage';
import { UsersTier } from './UsersTier';
import TiersRepository from '@/services/repository/TiersRepository';
import VueUtilities from '@/services/VueUtilities';
import AuthenticationCalls from '@/services/AuthenticationCalls';
import router from '@/router';
import i18n from '@/lang/lang';
var tiersRepository;
var authenticationCalls;
export class FeaturesManager {
    LS_TAG = SessionStorage.keys.FEATURES;
    static _instance;
    tier;
    constructor() {
        tiersRepository = new TiersRepository();
        authenticationCalls = new AuthenticationCalls();
    }
    static getInstance(reload = false) {
        if (!this._instance || reload) {
            this._instance = new this();
        }
        return this._instance;
    }
    async loadTier() {
        let response = await tiersRepository.getActiveTier();
        if (!(response instanceof UsersTier))
            throw i18n.t('error_messages.fatal_error');
        else {
            SessionStorage.storeData(this.LS_TAG, response);
            this.tier = response;
            return response;
        }
    }
    getTier() {
        if (this.tier)
            return this.tier;
        else {
            let cachedData = SessionStorage.loadData(this.LS_TAG);
            if (cachedData) {
                this.tier = cachedData.data;
                return this.tier;
            }
            else {
                //when there is no user tiers loaded, load tier for current department and reload current route.
                this.loadTier().then(() => {
                    router.go(0);
                });
            }
        }
    }
    isEnabled(feature) {
        let currentTier = this.getTier();
        if (!currentTier)
            return false;
        let enabledFeatures = currentTier.enabledFeatures;
        return enabledFeatures.filter((x) => x.Name == feature).length > 0;
    }
    isAvailable(feature) {
        return this.isEnabled(feature);
    }
    static showFeatureDisabledMsg() {
        VueUtilities.openErrorToast(i18n.t('tiers.features.disabled_msg'));
    }
    static showQuotaReachedMsg() {
        VueUtilities.openErrorToast(i18n.t('tiers.features.quota_msg'));
    }
}
